/**
 * Shared display label utilities — canonical implementations.
 * Import these instead of defining local copies in each page/component.
 */

export function decorationLabel(type: string): string {
  switch (type) {
    case "screenprint": return "Screenprinting";
    case "embroidery": return "Embroidery";
    case "heat_press": return "Heatpress Transfer";
    case "poly_bagging": return "Polybagging";
    case "undetermined": return "TBD";
    default: return type;
  }
}

/**
 * HUB-497: proof surfaces name each image by what it shows, not by where it is attached.
 * Every surface that renders a proof (WO run lines, the run detail modal, the printed job
 * ticket) must read these strings from here so the three can never drift apart.
 */
export const FINISHED_GOODS_PROOF_LABEL = "FINISHED GOODS PROOF";
export const ADDITIONAL_PROOF_LABEL = "ADDITIONAL PROOF";

export function decorationZoomLabel(type: string | null | undefined): string {
  switch (type) {
    case "screenprint": return "SCREENPRINT ZOOM";
    case "embroidery": return "EMBROIDERY ZOOM";
    case "heat_press": return "HEAT PRESS ZOOM";
    case "poly_bagging": return "POLYBAG ZOOM";
    // An undetermined or future decoration type must still name the image it shows rather
    // than render "undefined ZOOM" on a printed ticket.
    default: return "DECO ZOOM";
  }
}

export function statusLabel(status: string): string {
  switch (status) {
    case "pending": return "Unscheduled";
    case "ready": return "Production Ready";
    case "packing": return "Packed";
    default: return status.charAt(0).toUpperCase() + status.slice(1);
  }
}
